import Validation from "../../../Validation/WarehouseValidation";
import React, { Fragment, useEffect, useState } from "react";
import InputField from "../../../FormComponents/InputField";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import FormAlert from "../../../components/FormAlert";
import { addCustomer } from "../../../services/Customer";
import { Warehouse } from "@mui/icons-material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import FactoryIcon from "@mui/icons-material/Factory";
import { addWarehouse } from "../../../services/Warehouse";

const warehouses = [
  {
    id: 1,
    title: "Factory",
    description: "Factory as Warehouse.",
    icon: <FactoryIcon fontSize="small" />,
  },
  {
    id: 2,
    title: "Lorry",
    description: "Lorry as Warehouse.",
    icon: <LocalShippingIcon fontSize="small" />,
  },
];

function WarehouseFrom({ setOpenForm }) {
  const [selectedCard, setSelectedCard] = React.useState(0);
  //for input feild values
  const [values, setValues] = useState({
    _name: "",
    _type: "",
  });

  //Reset values
  const resetValues = () => {
    closeAlert();
    setValues({
      _name: "",
      _type: "",
    });
  };

  //display alert...
  const [displayAlert, setAlert] = useState(false);

  //alert data
  const [alertData, setAlertData] = useState({
    type: "",
    message: "",
  });

  const closeAlert = () => {
    setAlert(false);
    setAlertData({
      type: "",
      message: "",
    });
  };

  // errors for inputfeild
  const [error, setError] = useState({});

  //reset errors...
  const resetErrors = () => {
    setError({});
  };

  const submitValue = async () => {
    let warehouseType = warehouses[selectedCard].title;
    let warehouseData = {
      ...values,
      _type: warehouseType,
    };
    const validationErrors = Validation(values);

    console.log("Validation function output:", validationErrors);
    setError(Validation(values));
    console.log("error : ", error);
    if (Object.keys(validationErrors).length === 0) {
      console.log("Selected Card: ", warehouses[selectedCard].title);

      console.log("Warehouse data: ", warehouseData);

      let warehouseResponse = await addWarehouse(warehouseData);

      if (warehouseResponse) {
        resetValues();
        setAlertData({
          type: "success",
          message: "Warehouse Added..",
        });
        setAlert(true);
      } else {
        setAlertData({
          type: "error",
          message: "Something went wrong...",
        });
        setAlert(true);
      }
    }
  };

  //to handle changing value
  const handleChange = (name, val) => {
    resetErrors();
    console.log(name, val);
    setValues({
      ...values,
      [name]: val,
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={11} sx={12}>
        <Typography mt={1} variant="h6">
          {" "}
          Add Warehouse{" "}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={1} sx={12}>
        <Tooltip title="Close">
          <IconButton
            onClick={() => {
              setOpenForm(false);
            }}
            aria-label="close"
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid item xs={12} sm={4} sx={12}>
        <InputField
          name="_name"
          errorMsg={error._name}
          value={values._name}
          onChange={(event, newInputValue) =>
            handleChange(event, newInputValue)
          }
          type="text"
          label="Warehouse Name"
        />
      </Grid>
      <Grid item xs={12} sm={12} sx={12}>
        <Grid container spacing={2}>
          {warehouses.map((warehouse, index) => (
            <Grid item>
              <Card>
                <CardActionArea
                  onClick={() => setSelectedCard(index)}
                  data-active={selectedCard === index ? "" : undefined}
                  sx={{
                    height: "100%",
                    "&[data-active]": {
                      backgroundColor: "action.selected",
                      "&:hover": {
                        backgroundColor: "action.selectedHover",
                      },
                    },
                  }}
                >
                  <CardContent sx={{ height: "100%", maxWidth: "200px" }}>
                    <Grid container>
                      <Grid item xs={2} style={{ marginTop: "5px" }}>
                        {warehouse.icon}
                      </Grid>
                      <Grid item xs={10}>
                        <Typography variant="h6" component="div">
                          {warehouse.title}
                        </Typography>
                      </Grid>
                      <Typography variant="body2" color="text.secondary">
                        {warehouse.description}
                      </Typography>
                    </Grid>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} sx={12}>
        {displayAlert ? (
          <FormAlert type={alertData.type} message={alertData.message} />
        ) : null}
      </Grid>
      <Grid item xs={12} sm={12} sx={12}>
        <Grid container justifyContent="space-between">
          <Grid item xs={12} sm={4} sx={12}>
            <Button fullWidth variant="contained" onClick={submitValue}>
              Submit
            </Button>
          </Grid>
          <Grid item xs={12} sm={1} sx={12}>
            <Button onClick={resetValues} variant="outlined">
              Reset
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default WarehouseFrom;
